const decideSiteVersion = function() {
    if (sessionStorage.getItem('notFirst')) return;
    sessionStorage.setItem('notFirst', true);
    const slugName = window.location.pathname;
    if (slugName !== 'index.html' && slugName !== 'india.html' && slugName !== '/') return;

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const isIndia = timezone === 'Asia/Kolkata' || timezone === 'Asia/Calcutta';

    if (isIndia && slugName !== 'india.html') {
        window.location.replace('/india.html');
        return;
    }
    
    if (!isIndia && slugName !== 'index.html') window.location.replace('/index.html');
};

export default decideSiteVersion;
